import { GRAPHQL_TYPE_PERSON, Person as GraphQlPerson } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity as GraphQlEntity, GRAPHQL_TYPE_ENTITY } from "@radivision/graphql/lib/ts/graphql/entity";
import * as React from "react";
import ProgressiveImage from "react-progressive-image";
import LazyLoad from "react-lazyload";
import { Environment } from "relay-runtime";
import { ProfileHeaderDetails } from "../../../component-configuration/profile-header-details";
import { REACT_USER_CONTEXT } from "../../../contexts/react-user-context";
import { getEntityHeaderDetails, getPersonHeaderDetails, getTodayDate as todayDate} from "../../../utilities/general";
import { ImageHelper } from "../../../utilities/image-helper";
import { DEFAULTS } from "../../../utilities/defaults";
import { MediaAsset } from "@radivision/graphql/lib/ts/graphql/media-asset";
import { PreviewKind } from "@radivision/graphql/lib/ts/graphql/preview-type";
import { TopLevelMediaKind } from "@radivision/graphql/lib/ts/graphql/top-level-media-type";
import { SVG } from "../../../component-configuration/svgs";
import { Toaster } from "../../page-framework/toaster";
import { XLProfileHeaderActions } from "./xl-profile-header-actions";
import { HeaderMoreMenu } from "./more-menu";
import { ClaimDropMenuModal } from "./claim-dropmenu-modal";
import AddToSavedButton from "../../page-framework/add-to-saved-button";
import { EditProfileButton } from "./edit-profile-button";
import { EditProfileModal } from "./edit-profile-modal";
import { InvestmentSidebarLink } from "../company/investment-sibar-link";
import { SidebarLinks } from "../profile-details-tab/sidebar-links/sidebar-links";
import {FOUNDER, ENTHUSIAST, INVESTOR} from "../../../redux/authentication/account-types";

const isEqual = require("lodash.isequal");

interface ProfileHeaderProps extends React.Props<string> {
  owner?: boolean;
  CanPublish?: boolean;
  /**
   * The type of profile (Entity/Person/Spectator).
   *
   */
  type?: string;

  /**
   * The name of the profile owner.
   *
   * @type {string}
   */
  name?: string;

  /**
   * The title of the profile owner.
   *
   * @type {string}
   */
  title?: string;

  /**
   * The work location of the profile owner.
   *
   * @type {string}
   */
  location?: string;

  /**
   * Graphql person object for this header.
   *
   * @type {(GraphQlPerson | GraphQlEntity)}
   * @memberof ProfileHeaderProps
   */
  value?: GraphQlPerson | GraphQlEntity;

  /**
   *
   * @type {MediaAsset[]}
   * @memberof ProfileHeaderProps
   */
  backgroundList?: MediaAsset[];

  /**
   *
   *
   * @type {Function}
   * @memberof ProfileHeaderProps
   */
  updateContext?: Function;
}

/**
 * The state of the ProfileHeader component.
 *
 * @interface
 */
interface ProfileHeaderState {

  /**
   *
   *
   * @type {}
   * @memberof ProfileHeaderProps
   */

  /**
   * indicates if the current user is following this profile or not.
   *
   * @type {boolean}
   * @memberof ProfileHeaderState
   */
  following?: boolean | any;

  /**
   * indicates if there is a call to the back end running.
   *
   * @type {boolean}
   * @memberof ProfileHeaderState
   */
  loading?: boolean;

  /**
   * save user original social profile urls before any editing.
   *
   * @type {*}
   * @memberof ProfileHeaderState
   */
  originalSocialProfiles: any;

  /**
   * indicates if there is a call to the back end running.
   *
   * @type {boolean}
   * @memberof ProfileHeaderState
   */
  disabled?: boolean;
  /**
   *
   * @type {GraphQlPerson}
   * @memberof ProfileHeaderState
   */
  value: any;
  /**
   *
   *
   * @type {ProfileHeaderDetails}
   * @memberof ProfileHeaderState
   */
  profileDetails: ProfileHeaderDetails;

  /**
   *
   *
   * @type {*}
   * @memberof ProfileHeaderState
   */
  uploadedFile?: any;


  /**
   *
   *
   * @type {boolean}
   * @memberof ProfileHeaderState
   */
  selected?: boolean;

  /**
   * the title for the Sign In modal
   *
   * @type {string}
   */
  signInModalTitle: string;

  /**
   * the message that will appear after successful request
   *
   * @type {string}
   * @memberof ProfileHeaderState
   */
  successMessage: string;
  section: string;
}

/**
 * A React component which renders all flavours of Profile Header.
 *
 * @extends {React.Component<ProfileHeaderProps>}
 */
export class ProfileHeader extends React.Component<ProfileHeaderProps, ProfileHeaderState> {
  /**
   * A reference to the media modal element.
   *
   * @type {React.RefObject<{}>}
   */
  mediaModalRef: React.RefObject<any>;

  /**
   * A reference to the add Background Media Modal.
   *
   * @type {React.RefObject<{}>}
   */
  backgroundMediaModalRef: React.RefObject<any>;

  /**
   * Constructor.
   *
   * @param {ProfileHeaderProps} props The props of the component.
   */
  constructor(props: ProfileHeaderProps) {
    super(props);
    

    let profileDetails: ProfileHeaderDetails;
    const rdvButton: { buttonText: string } = { buttonText: "follow" };

    if (this.props.value === undefined || this.props.value === null) {
      profileDetails = null;
    } else if (this.props.type === GRAPHQL_TYPE_PERSON) {
      profileDetails = getPersonHeaderDetails(this.props.value, {
        containerWidthRatio: 3 / 12,
        numberOfItems: 4,
      });
    } else {
      profileDetails = getEntityHeaderDetails(this.props.value, {
        containerWidthRatio: 3 / 12,
        numberOfItems: 4,
      });
    }

    if (this.props.owner) {
      rdvButton.buttonText = "edit profile";
    }
    // creating needed references
    this.mediaModalRef = React.createRef();
    this.backgroundMediaModalRef = React.createRef();

    const errorHandler: {
      hasError: boolean;
      errorCode: string;
      errorMessage: string;
    } = {
      errorCode: undefined,
      errorMessage: undefined,
      hasError: false,
    };

    // initialize components state
    this.state = {
      profileDetails,
      loading: false,
      value: this.props.value,
      selected: false,
      disabled: false,
      originalSocialProfiles: null,
      signInModalTitle: "",
      successMessage: "",
      section: "Page Info",
    };

  }

  componentDidMount() {
    // window.addEventListener("hashchange", this.onHashChange, false);
    // if ($("#editProfileModal").length) {
    //   $("#editProfileModal").on("hide.bs.modal", (event) => {
    //     this.onCancel();
    //   });
    // }
  }

  componentWillUnmount() {
    // window.removeEventListener("hashchange", this.onHashChange, false);
  }

  componentDidUpdate(prevProps: ProfileHeaderProps) {
    if (!isEqual(this.props.value, prevProps.value)) {
      const newProfileDetails =
        this.props.type === GRAPHQL_TYPE_PERSON
          ? getPersonHeaderDetails(this.props.value, {
              containerWidthRatio: 3 / 12,
              numberOfItems: 4,
            })
          : getEntityHeaderDetails(this.props.value, {
              containerWidthRatio: 3 / 12,
              numberOfItems: 4,
            });
      let originalSocialProfiles = Object.assign({}, newProfileDetails.socialMediaProfiles);
      if (newProfileDetails.socialMediaProfiles === null) {
        originalSocialProfiles = {
          FacebookID: "",
          InstagramID: "",
          LinkedInID: "",
          TwitterID: "",
        };
      }

      this.setState({
        originalSocialProfiles,
        value: this.props.value,
        profileDetails: newProfileDetails,
      });
    }
  }

  loadDefaultImage(targetImage: any, itemType: any) {
    targetImage.onerror = null;
    targetImage.src = ImageHelper.fetchOptimizedImageUrl({
      imageType: "DEFAULT",
      default: {
        previewType: PreviewKind.SQUARE,
        mediaType: TopLevelMediaKind.IMAGE,
        type: itemType,
      },
      desiredDimensions: { containerWidthRatio: 1, numberOfItems: 6 },
      isSquareImage: true,
      revision: undefined,
    }).requestedResolutionUrl;
  }

  render(): React.ReactNode {
    let item: ProfileHeaderDetails;
    
    if (this.state.value === undefined || this.state.value === null) {
      item = {};
    } else if (this.props.type === GRAPHQL_TYPE_PERSON) {
      item = getPersonHeaderDetails(this.state.value, {
        containerWidthRatio: 5 / 12,
        numberOfItems: 1,
      });
    } else {
      item = getEntityHeaderDetails(this.state.value, {
        containerWidthRatio: 5 / 12,
        numberOfItems: 1,
      });
    }

    const subject = this.props.value;
    const isPerson = this.props.type === GRAPHQL_TYPE_PERSON;
    const accountType = isPerson ? (
      subject?.accountType?.kind === ENTHUSIAST.kind
        ? "Community Member"
        : subject?.accountType?.kind === FOUNDER.kind
        ? "Founder"
        : subject?.accountType?.kind === INVESTOR.kind
        ? "Investor"
      : "") : null;


    return (
      <div className="profile-header">
        {this.state.successMessage.length > 0 && (
          <Toaster
            autoHide={true}
            message={this.state.successMessage}
            type="success"
            onClose={() => this.setState({ successMessage: "" })}
          />
        )}
        <div className="profile-header-container">
          <div className="profile-header-background" key={item?.backgroundImgUrl?.requestedResolutionUrl}>
            {item.backgroundImgUrl ? (
              <ProgressiveImage
                src={
                  item.backgroundImgUrl.requestedResolutionUrl !== undefined &&
                  item.backgroundImgUrl.requestedResolutionUrl !== null
                    ? item.backgroundImgUrl.requestedResolutionUrl
                    : item.backgroundImgUrl.screenResolutionUrl
                }
                placeholder={item.backgroundImgUrl.placeHolderUrl}
              >
                {(src: any, LOADING: any, srcSetData: any) => (
                  <img
                    loading="lazy"
                    alt={`${item.name ? item.name : ""} background image`}
                    className={
                      this.props.type === "Entity"
                        ? "header-background entity-background "
                        : "header-background person-background"
                    }
                    src={src}
                  />
                )}
              </ProgressiveImage>
            ) : null}
          </div>
          <div className="pageData">
            <div className="personImage">
              {this.props.value === undefined || this.props.value === null ? null : item.profileImgUrl ? (
                <LazyLoad once={true}>
                  <ProgressiveImage
                    src={
                      item.profileImgUrl
                        ? item.profileImgUrl.requestedResolutionUrl !== undefined &&
                          item.profileImgUrl.requestedResolutionUrl !== null
                          ? item.profileImgUrl.requestedResolutionUrl
                          : item.profileImgUrl.screenResolutionUrl
                        : undefined
                    }
                    placeholder={item.profileImgUrl.placeHolderUrl}
                  >
                    {(src: any, LOADING: any, srcSetData: any) => (
                      <img
                        loading="lazy"
                        alt={`${item.name ? item.name : ""}`}
                        className="header-image"
                        src={src}
                        onError={(event) => {
                          this.loadDefaultImage(
                            event.target,
                            this.props.type === GRAPHQL_TYPE_PERSON ? GRAPHQL_TYPE_PERSON : GRAPHQL_TYPE_ENTITY,
                          );
                        }}
                      />
                    )}
                  </ProgressiveImage>
                </LazyLoad>
              ) : (
                <LazyLoad once={true}>
                  <ProgressiveImage
                    src={
                      this.props.type === GRAPHQL_TYPE_PERSON
                        ? `${process.env.URL_MEDIA_IMAGE}/${DEFAULTS["DEFAULT_Person_SQUARE"]}?wip=300`
                        : `${process.env.URL_MEDIA_IMAGE}/${DEFAULTS["DEFAULT_Entity_SQUARE"]}?wip=300`
                    }
                    placeholder={
                      this.props.type === GRAPHQL_TYPE_PERSON
                        ? `${process.env.URL_MEDIA_IMAGE}/${DEFAULTS["DEFAULT_Person_SQUARE"]}?wip=10`
                        : `${process.env.URL_MEDIA_IMAGE}/${DEFAULTS["DEFAULT_Entity_SQUARE"]}?wip=10`
                    }
                  >
                    {(src: any, LOADING: any, srcSetData: any) => (
                      <img
                        loading="lazy"
                        alt={`${item.name ? item.name : ""}`}
                        className="header-image"
                        src={src}
                        onError={(event) => {
                          this.loadDefaultImage(
                            event.target,
                            this.props.type === GRAPHQL_TYPE_PERSON ? GRAPHQL_TYPE_PERSON : GRAPHQL_TYPE_ENTITY,
                          );
                        }}
                      />
                    )}
                  </ProgressiveImage>
                </LazyLoad>
              )}
            </div>
            <div className="personData">
              <div className={`profile-info-top${this.props.type === GRAPHQL_TYPE_ENTITY ? " company-profile" : ""}`}>
                <div className="profile-name d-block d-xl-none">
                  <h4
                    className={`name${
                      this.props.type === GRAPHQL_TYPE_ENTITY
                        ? item.hasPortfolio
                          ? " entity org-profile"
                          : " entity"
                        : ""
                    }`}
                  >
                    {!this.props.value ? (
                      <span className="name-placeholder loading-gradient" />
                    ) : item.name ? (
                      item.name
                    ) : null}
                  </h4>
                  {this.props.type === GRAPHQL_TYPE_ENTITY ? (
                    <h6 className="profile-type">{item.hasPortfolio ? "Organization" : "Company"}</h6>
                  ) : 
                    <h6 className="profile-type">{accountType}</h6>
                  }
                </div>
                <XLProfileHeaderActions
                  value={this.props.value}
                  onChangeModalTitle={(title) => this.setState({ signInModalTitle: title })}
                  resetProfileDetails={this.resetEditProfileState}
                />
                {this.props.value !== null && this.props.value !== undefined ? (
                  <div className="profile-actions">
                    { this.props.owner && <EditProfileButton subject={this.props.value}/> }
                    { !this.props.owner && <AddToSavedButton item={this.props.value} label="Follow"/> }
                    <REACT_USER_CONTEXT.Consumer>
                      {(value: { user: GraphQlPerson; updateUser: Function }) => {

                        return (
                          <div>
                            <ul className="social-links">
                              <li>
                                {this.state.profileDetails &&
                                this.state.profileDetails.socialMediaProfiles &&
                                this.state.profileDetails.socialMediaProfiles.FacebookID ? (
                                  <a
                                    href={this.state.profileDetails.socialMediaProfiles.FacebookID}
                                    target="_blank"
                                    className={
                                      this.state.profileDetails.socialMediaProfiles &&
                                      this.state.profileDetails.socialMediaProfiles.FacebookID
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {SVG.facebookCircle}
                                  </a>
                                ) : this.props.owner ? (
                                  SVG.facebookCircle
                                ) : null}
                              </li>
                              <li className="twitter-icon">
                                {this.state.profileDetails &&
                                this.state.profileDetails.socialMediaProfiles &&
                                this.state.profileDetails.socialMediaProfiles.TwitterID ? (
                                  <a
                                    href={this.state.profileDetails.socialMediaProfiles.TwitterID}
                                    target="_blank"
                                    className={
                                      this.state.profileDetails.socialMediaProfiles &&
                                      this.state.profileDetails.socialMediaProfiles.TwitterID
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {SVG.twitter}
                                  </a>
                                ) : this.props.owner ? (
                                  SVG.twitter
                                ) : null}
                              </li>
                              <li>
                                {this.state.profileDetails &&
                                this.state.profileDetails.socialMediaProfiles &&
                                this.state.profileDetails.socialMediaProfiles.LinkedInID ? (
                                  <a
                                    href={this.state.profileDetails.socialMediaProfiles.LinkedInID}
                                    target="_blank"
                                    className={
                                      this.state.profileDetails.socialMediaProfiles &&
                                      this.state.profileDetails.socialMediaProfiles.LinkedInID
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {SVG.linkedinSquare}
                                  </a>
                                ) : this.props.owner ? (
                                  SVG.linkedinSquare
                                ) : null}
                              </li>
                              <li>
                                {this.state.profileDetails &&
                                this.state.profileDetails.socialMediaProfiles &&
                                this.state.profileDetails.socialMediaProfiles.InstagramID ? (
                                  <a
                                    href={this.state.profileDetails.socialMediaProfiles.InstagramID}
                                    target="_blank"
                                    className={
                                      this.state.profileDetails.socialMediaProfiles &&
                                      this.state.profileDetails.socialMediaProfiles.InstagramID
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    {SVG.instagram}
                                  </a>
                                ) : this.props.owner ? (
                                  SVG.instagram
                                ) : null}
                              </li>
                            </ul>
                            <HeaderMoreMenu
                              subject={this.state.value}
                              onChangeModalTitle={(title) => this.setState({ signInModalTitle: title })}
                              resetProfileDetails={this.resetEditProfileState}
                            />
                          </div>
                        );
                      }}
                    </REACT_USER_CONTEXT.Consumer>
                  </div>
                ) : null}
              </div>
              <div className="profile-info-bottom">
                <h5 className="description">
                  {!this.props.value ? (
                    <span className="description-placeholder loading-gradient" />
                  ) : this.props.value.__typename === GRAPHQL_TYPE_ENTITY ? (
                    item.tagLine
                  ) : (
                    item.title
                  )}
                </h5>
                {item?.websiteUrl ? (
                  <a href={item?.websiteUrl?.includes("http") ? item?.websiteUrl : `//${item?.websiteUrl}`} className="websiteURL" target="_blank">
                    {SVG.externalLinkAlt}
                    {item.websiteUrl}
                  </a>
                ) : null}
                <InvestmentSidebarLink entity={this.props.value} />
                <div className="social-links">
                <SidebarLinks subject={this.props.value} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <EditProfileModal />
        <ClaimDropMenuModal
          subject={this.state.value}
          onChangeModalTitle={(title) => {
            this.setState({ signInModalTitle: title });
          }}
        />
      </div>
    );
  }
